<template>
  <div>
    <div class="app-title">
      <div>
        <h1><i class="fas fa-list"></i> รายงานสรุปรายเดือน</h1>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>

    <!-- Navbar with Filters -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <!-- Dropdowns or additional menu items can be added here -->
        </ul>

        <div class="form-inline mr-2">
          <label class="mr-2">เลือกปี</label>
          <select v-model="selectedYear" class="custom-select">
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>

        <!-- Month Selection -->
        <form class="form-inline my-2 my-lg-0">
          <div class="form-group mr-2">
            <select
              v-model="selectedMonth"
              class="custom-select"
              id="monthSelect"
            >
              <option
                :value="month.id"
                v-for="(month, index) in months"
                :key="index"
              >
                {{ month.name }}
              </option>
            </select>
          </div>
        </form>

        <button class="btn btn-primary" @click="exportToExcel">
          Export to Excel
        </button>
      </div>
    </nav>

    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">
              รายงานเดือน {{ monthName }} {{ selectedYear }}
            </h3>
          </div>
          <div class="tile-body">
            <!-- Only show the chart once the data is loaded -->
            <bar-chart
              v-if="loaded"
              :chart-data="chartData"
              :options="chartOptions"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BarChart from "../components/BarChart.vue";
import httpCommon from "../services/http-common";
import * as XLSX from "xlsx";

export default {
  components: { BarChart },
  watch: {
    selectedMonth() {
      this.fetchChartData();
    },
    selectedYear() {
      this.fetchChartData();
    },
  },
  computed: {
    monthName() {
      const months = {
        "01": "มกราคม",
        "02": "กุมภาพันธ์",
        "03": "มีนาคม",
        "04": "เมษายน",
        "05": "พฤษภาคม",
        "06": "มิถุนายน",
        "07": "กรกฎาคม",
        "08": "สิงหาคม",
        "09": "กันยายน",
        10: "ตุลาคม",
        11: "พฤศจิกายน",
        12: "ธันวาคม",
      };
      return months[this.selectedMonth];
    },
  },
  data() {
    const today = new Date();

    return {
      years: [],
      months: [
        { id: "01", name: "มกราคม" },
        { id: "02", name: "กุมภาพันธ์" },
        { id: "03", name: "มีนาคม" },
        { id: "04", name: "เมษายน" },
        { id: "05", name: "พฤษภาคม" },
        { id: "06", name: "มิถุนายน" },
        { id: "07", name: "กรกฎาคม" },
        { id: "08", name: "สิงหาคม" },
        { id: "09", name: "กันยายน" },
        { id: "10", name: "ตุลาคม" },
        { id: "11", name: "พฤศจิกายน" },
        { id: "12", name: "ธันวาคม" },
      ],
      selectedMonth: moment().format("MM"),
      selectedYear: moment().format("YYYY"),
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Software",
            data: [],
            backgroundColor: "#42A5F5",
          },
          {
            label: "Hardware",
            data: [],
            backgroundColor: "#66BB6A",
          },
          {
            label: "Printer",
            data: [],
            backgroundColor: "#FFCA28",
          },
          {
            label: "Internet Network",
            data: [],
            backgroundColor: "#FF7043",
          },
          {
            label: "CCTV",
            data: [],
            backgroundColor: "#AB47BC",
          },
          {
            label: "HOSxP",
            data: [],
            backgroundColor: "#8D6E63",
          },
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
          datalabels: {
            display: true,
            color: "black",
            font: {
              weight: "bold",
              size: 14,
            },
            anchor: "end",
            align: "top",
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
      loaded: false,
    };
  },
  mounted() {
    this.fetchChartData();
  },
  methods: {
    async fetchChartData() {
      this.loaded = false;

      try {
        const response = await httpCommon.get(
          `monthly?month=${this.selectedYear}-${this.selectedMonth}`
        );

        this.chartData.labels = [];
        this.chartData.datasets.forEach((dataset) => {
          dataset.data = [];
        });

        response.data.data.forEach((userData) => {
          this.chartData.labels.push(userData.User);
          this.chartData.datasets[0].data.push(userData.Software);
          this.chartData.datasets[1].data.push(userData.Hardware);
          this.chartData.datasets[2].data.push(userData.Printer);
          this.chartData.datasets[3].data.push(userData.InternetNetwork);
          this.chartData.datasets[4].data.push(userData.CCTV);
          this.chartData.datasets[5].data.push(userData.HOSxP);
        });

        this.loaded = true;
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    },

    exportToExcel() {
      const ws_data = [];

      ws_data.push([
        "User",
        "Software",
        "Hardware",
        "Printer",
        "Internet Network",
        "CCTV",
        "HOSxP",
      ]);

      this.chartData.labels.forEach((label, index) => {
        ws_data.push([
          label,
          this.chartData.datasets[0].data[index],
          this.chartData.datasets[1].data[index],
          this.chartData.datasets[2].data[index],
          this.chartData.datasets[3].data[index],
          this.chartData.datasets[4].data[index],
          this.chartData.datasets[5].data[index],
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Monthly Report");

      XLSX.writeFile(wb, "monthly_report.xlsx");
    },
  },
  created() {
    const currentYear = moment().year();
    for (let i = -3; i <= 3; i++) {
      this.years.push(currentYear + i);
    }
  },
};
</script>

<style scoped>
/* Optional: Add any custom styling you need for the chart */
.tile-body {
  padding: 20px;
  background-color: #fff;
}
</style>
